import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * page-visit operation
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const visitPage = async ({
  request,
}: {
  request: ApiTypes["page-visit"]["request"];
}): Promise<ApiTypes["page-visit"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["page-visit"]["response"]
    >(`/api/public/v2025-06/events/pages/visit`, request);
    return response.data;
  } catch (error) {
    handleApiError(error as Error, "Failed to visitPage");
    throw error;
  }
};

/**
 * page-visit operation using navigator.sendBeacon for reliable delivery during page unload
 * @param request - The request data
 * @returns boolean indicating if the beacon was successfully queued
 */
export const visitPageBeacon = ({
  request,
}: {
  request: ApiTypes["page-visit"]["request"];
}): boolean => {
  try {
    const url = `${axiosInstance.defaults.baseURL}/api/public/v2025-06/events/pages/visit`;

    // Send request body as beacon data
    const blob = new Blob([JSON.stringify(request)], {
      type: "application/json",
    });

    return navigator.sendBeacon(url, blob);
  } catch (error) {
    console.error("Failed to send beacon for visitPage:", error);
    return false;
  }
};
